/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { ref } from '@vue/composition-api';

function useTreeState(props, store) {
  var treeContentRef = ref();
  var nodes = ref([]);
  var allNodes = ref([]);
  var isScrolling = ref(false);
  allNodes.value = store.getNodes();
  var state = {
    store: store,
    treeContentRef: treeContentRef,
    nodes: nodes,
    allNodes: allNodes,
    isScrolling: isScrolling,
    mouseEvent: null,
    virtualConfig: null,
    scope: {
      treeContentRef: treeContentRef,
      treeProps: props,
      scopedSlots: {},
      virtualConfig: null
    }
  };
  return {
    isScrolling: isScrolling,
    treeContentRef: treeContentRef,
    state: state
  };
}

export { useTreeState as default };
//# sourceMappingURL=useTreeState.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/hooks/useTreeState.js
// module id = null
// module chunks = 